/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetNewRefreshTokenRequest } from '../../models/get-new-refresh-token-request';
import { GetNewRefreshTokenResponse } from '../../models/get-new-refresh-token-response';

export interface GetNewRefreshToken$Params {
      body: GetNewRefreshTokenRequest
}

export function getNewRefreshToken(http: HttpClient, rootUrl: string, params: GetNewRefreshToken$Params, context?: HttpContext): Observable<StrictHttpResponse<GetNewRefreshTokenResponse>> {
  const rb = new RequestBuilder(rootUrl, getNewRefreshToken.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetNewRefreshTokenResponse>;
    })
  );
}

getNewRefreshToken.PATH = '/management/v0/auth/refresh-tokens';
